document.addEventListener("DOMContentLoaded", function () {
  const cards = document.querySelectorAll("[data-bundle-card]");
  const summaryList = document.getElementById("BundleSummaryList");
  const totalPriceEl = document.getElementById("BundleTotalPrice");
  const oldPriceEl = document.getElementById("BundleOldPrice");
  const saveAmountEl = document.getElementById("BundleSaveAmount");
  const savingsWrapper = document.getElementById("BundleSavingsWrapper");
  const submitBtn = document.getElementById("NinjaBundleSubmitBtn");
// ninja-bundle-summary__btn NinjaBundleSubmitBtn
  // Format Currencies to Indian Rupees (INR) Default Style
  function formatCurrency(amount) {
    return "₹" + Number(amount).toLocaleString("en-IN", {
      maximumFractionDigits: 0
    });
  }

  // Calculate live numbers and rebuild summary rows
  function updateBundleSummary() {
    let totalPrice = 0;
    let totalMRP = 0;
    let htmlOutput = "";

    cards.forEach((card) => {
      const checkbox = card.querySelector(".ninja-bundle-card__checkbox-hidden");
      const isChecked = checkbox.checked;
      const itemPrice = parseFloat(checkbox.dataset.price);
      const itemMRP = parseFloat(checkbox.dataset.mrp);
      const itemTitle = checkbox.dataset.title;

      if (isChecked) {
        totalPrice += itemPrice;
        totalMRP += itemMRP;
        
        // Active selected row line item
        htmlOutput += `
          <div class="summary-item-row">
            <span>${itemTitle}</span>
            <span>${formatCurrency(itemPrice)}</span>
          </div>
        `;
      } else {
        // Unselected / disabled item view line row
        htmlOutput += `
          <div class="summary-item-row is-muted">
            <span>${itemTitle}</span>
            <span>${formatCurrency(itemPrice)}</span>
          </div>
        `;
      }
    });

    // Render updated rows structure
    summaryList.innerHTML = htmlOutput;
    totalPriceEl.textContent = formatCurrency(totalPrice);

    // Calculate savings amounts dynamically
    if (totalMRP > totalPrice) {
      savingsWrapper.style.display = "flex";
      oldPriceEl.textContent = formatCurrency(totalMRP);
      const savingsDiff = totalMRP - totalPrice;
      saveAmountEl.textContent = `Save ${formatCurrency(savingsDiff)}`;
    } else {
      savingsWrapper.style.display = "none";
    }
  }

  // Toggle selection states triggers on click
  cards.forEach((card) => {
    card.addEventListener("click", function (e) {
      // Prevent double triggers if clicked near checkbox bounds directly
      if (e.target.tagName === "INPUT") return;

      const checkbox = this.querySelector(".ninja-bundle-card__checkbox-hidden");
      checkbox.checked = !checkbox.checked;
      
      if (checkbox.checked) {
        this.classList.add("is-selected");
      } else {
        this.classList.remove("is-selected");
      }
      
      updateBundleSummary();
    });
  });

  // Handle Shopify AJAX Multi Item Form Submissions Click Events
  // if (submitBtn) {
  //   submitBtn.addEventListener("click", function () {
  //     const selectedItems = [];

  //     cards.forEach((card) => {
  //       const checkbox = card.querySelector(".ninja-bundle-card__checkbox-hidden");
  //       if (checkbox.checked) {
  //         selectedItems.push({
  //           id: parseInt(checkbox.dataset.variantId),
  //           quantity: 1
  //         });
  //       }
  //     });

  //     if (selectedItems.length === 0) {
  //       alert("Please select at least one item to build your bundle set!");
  //       return;
  //     }

  //     // Toggle UI Loader state
  //     const btnText = submitBtn.querySelector(".btn-text");
  //     const btnLoader = submitBtn.querySelector(".btn-loader");
  //     btnText.style.display = "none";
  //     btnLoader.style.display = "inline";
  //     submitBtn.disabled = true;

  //     // Shopify Standard cart addition endpoints fetch request standard
  //     fetch(window.Shopify.routes.root + "cart/add.js", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json"
  //       },
  //       body: JSON.stringify({ items: selectedItems })
  //     })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       // Redirect users directly to cart page to complete bundle purchase funnel
  //       document.querySelector('cart-drawer')?.open();
  //       // window.location.href = "/cart";
  //     })
  //     .catch((error) => {
  //       console.error("Error adding bundle pack items:", error);
  //       alert("Something went wrong. Please try again.");
  //       btnText.style.display = "inline";
  //       btnLoader.style.display = "none";
  //       submitBtn.disabled = false;
  //     });
  //   });
  // }
if (submitBtn) {

  submitBtn.addEventListener("click", async function () {

    const selectedItems = [];

    // Collect selected products
    cards.forEach((card) => {

      const checkbox = card.querySelector(
        ".ninja-bundle-card__checkbox-hidden"
      );

      if (checkbox && checkbox.checked) {

        selectedItems.push({
          id: parseInt(checkbox.dataset.variantId),
          quantity: 1
        });

      }

    });

    // Validation
    if (selectedItems.length === 0) {

      alert("Please select at least one item!");

      return;
    }

    // Button loading state
    const btnText   = submitBtn.querySelector(".btn-text");
    const btnLoader = submitBtn.querySelector(".btn-loader");

    if (btnText) btnText.style.display = "none";
    if (btnLoader) btnLoader.style.display = "inline-flex";

    submitBtn.disabled = true;
    submitBtn.classList.add("loading");

    try {

      // Add bundle items to Shopify cart
      const response = await fetch(
        window.Shopify.routes.root + "cart/add.js",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            items: selectedItems
          })
        }
      );

      if (!response.ok) {
        throw new Error("Failed to add bundle");
      }

      await response.json();

      // =========================
      // OPEN CART DRAWER
      // =========================

      // Theme cart icon trigger
      const cartTrigger =
        document.querySelector('.header__icon--cart') ||
        document.querySelector('a[href="/cart"]') ||
        document.querySelector('[data-cart-toggle]');

      if (cartTrigger) {

        cartTrigger.click();

      } else {

        // fallback
        window.location.href = "/cart";

      }

    } catch (error) {

      console.error(
        "Bundle add-to-cart error:",
        error
      );

      alert(
        "Something went wrong. Please try again."
      );

    } finally {

      // Reset button state
      if (btnText) btnText.style.display = "inline-flex";
      if (btnLoader) btnLoader.style.display = "none";

      submitBtn.disabled = false;
      submitBtn.classList.remove("loading");

    }

  });

}
  // Initial runtime load calculation trigger
  updateBundleSummary();
});